import { useEffect, useState } from 'react';
import './Main.scss';
import { Results } from '../Results/Results';
import { Survey, SurveyView } from '../Survey/Survey';
import { NavBar } from '../shared/NavBar';
import Logo from '../../assets/images/logo.svg';
import { BackgroundLayer } from '../Survey/BackgroundLayer/BackgroundLayer';
import classNames from 'classnames';
import { linkTo } from '../Results/utils';
import { NewForm } from '../Form/NewForm';

export enum AppView {
  Intro = 'intro',
  Form = 'form',
  Survey = 'survey',
  Results = 'results'
}

function iOSSafari(userAgent: string) {
  return /iP(ad|od|hone)/i.test(userAgent) &&
    /WebKit/i.test(userAgent) &&
    !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(userAgent));
}

function App() {
  const [answers, setAnswers] = useState<{ [qNumber: number]: number }>({});
  const [view, setView] = useState(AppView.Survey);
  const [pageNumber, setPageNumber] = useState(0);
  const [surveyView, setSurveyView] = useState(SurveyView.Intro);
  const [mobileResultActive, setMobileResultActive] = useState(false);

  useEffect(() => { window.scroll(0, 0) }, [view]);

  return (
    <div className={classNames(
      iOSSafari(navigator.userAgent) && 'iphone',
      view === AppView.Form ? 'h-full' : 'h-auto',
      "app w-full flex flex-col items-center relative"
    )}>
      <a href="#main-content" className="absolute left-0 top-0 bg-crayola-pink text-white py-2 px-4 z-50 transform -translate-y-full focus:translate-y-0 transition">
        Skip to main content
      </a>
      {view === AppView.Survey && <BackgroundLayer surveyView={surveyView} pageNumber={pageNumber} />}
      {view !== AppView.Form && <NavBar view={view} onExit={() => setView(AppView.Intro)} />}
      <div className={classNames("content h-full w-full flex justify-center items-center", view !== AppView.Form && "mt-[118px]")}>
        {
          view === AppView.Survey && <Survey
            pageNumber={pageNumber}
            setPageNumber={(page: number) => setPageNumber(page)}
            setView={(view: AppView) => setView(view)}
            setSurveyView={(view: SurveyView) => setSurveyView(view)}
            surveyView={surveyView}
            answers={answers}
            onAnswerSelect={(questionNumber: number, answer: number) => setAnswers({...answers, [questionNumber]: answer })}
          />
        }
        {
          view === AppView.Results && <Results
            mobileResultActive={mobileResultActive}
            setMobileResultActive={setMobileResultActive}
            setAppView={(view: AppView) => setView(view)}
            answers={answers}
          />
        }
        {view === AppView.Form && <NewForm setView={(view) => setView(view)} />}
      </div>
      {view !== AppView.Form && <footer role="contentinfo" className={classNames(
        "md:bg-transparent md:z-[999] w-full h-[134px] flex flex-col gap-2 justify-center items-center",
        view === AppView.Results ? 'bg-[#E7F8AF] relative bottom-0' : 'bottom-[-10px]',
        view === AppView.Results && mobileResultActive && 'bottom-48 bg-transparent',
        ((view === AppView.Survey && surveyView === SurveyView.Intro) ||
          (view === AppView.Survey && surveyView === SurveyView.Main && pageNumber >= 6)) && 'bg-[#CDF1F6]',
        view === AppView.Survey && surveyView === SurveyView.Main && pageNumber >= 0 && pageNumber < 3 && 'bg-[#E7F8AF]',
        view === AppView.Survey && surveyView === SurveyView.Main && pageNumber >= 3 && pageNumber < 6 && 'bg-[#FDCFED]',
        view === AppView.Survey && 'mb-12 min-[1100px]:mb-0'
  )   }>
        <img alt="Crayola Logo" src={Logo} className="w-[145px]"/>
        <div className="flex justify-center gap-8">
          <button role="link" className="text-crayola-dark-blue underline" onClick={() => linkTo("https://www.crayola.com/terms-of-use.aspx")}>Terms of Use</button>
          <button role="link" className="text-crayola-dark-blue underline" onClick={() => linkTo("https://www.crayola.com/privacy.aspx")}>Privacy Policy</button>
        </div>
      </footer>}
    </div>
  );
}

export default App;
